import type { Device, User } from "luxedo-data"
import type { BundledAccountData } from "luxedo-rpc/src/types/BundledTypes"
import { navigate } from "svelte-routing"

export function viewUser(user: User | number | BundledAccountData) {
	if (typeof user === "number") return navigate(`/admin/user/${user}`)
	return navigate(`/admin/user/${user.id}`)
}

export function viewDevice(device: Device | number) {
	if (typeof device === "number") return navigate(`/admin/device/${device}`)
	return navigate(`/admin/device/${device.id}`)
}
